import React, { useEffect } from "react";
import { redirect, useNavigate, useSearchParams } from "react-router-dom";
import { API_BASE_URL, AuthRoutes } from "../../constants/Constants";
import { getEnv } from '../../helpers/EnvHelper';

const GizmoViewer = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const loginAndFetchToken = async () => {
  try {
    const formData = new FormData();
    formData.append("username", "dtadmin");
    formData.append("password", "Dtadmin$0978");

    const res = await fetch(`${getEnv("REACT_APP_RAI_BASE_URL")}api/rai/auth/login`, {
      method: "POST",
      body: formData, // ✅ automatically sets correct Content-Type
    });

    const result = await res.json();

    if (result.success && result.access_token) {
        localStorage.removeItem("raiToken");
      localStorage.setItem("raiToken", result.access_token);
      localStorage.setItem("raiClientID", result.clientID);

        document.cookie = `raiToken=${result.access_token}; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;
        document.cookie = `clientID=${result.clientID}; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;
        document.cookie = `projectID=473686; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;
        document.cookie = `role=superadmin; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;
        document.cookie = `username=dtadmin; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;


      return result.access_token;
    } else {
      throw new Error(result.message || "RAI login failed");
    }
  } catch (err) {
    console.error("RAI login failed:", err);
    // setErrorMessage("RAI login failed");
  }
};

const fetchFilterData = async (pathologyList) => {
  try {
    const raiToken = localStorage.getItem("raiToken");
    const clientID = localStorage.getItem("raiClientID");

    const params = new URLSearchParams({
      projectID: "473686",
      clientID: clientID || "138c4fc9afdadeb856f40b05be06959f",
      prediction: "ai",
    });

    const response = await fetch(
      `${getEnv("REACT_APP_RAI_BASE_URL")}api/rai/filters?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${raiToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (!result.success) {
      console.error("❌ Failed to fetch RAI filters:", result.message);
      return;
    }

    console.log("RAI filter data (original):", result.data);

    // ✅ Replace singleFindingOption with pathologyList
    if (pathologyList) {
      result.data.singleFindingOption = Array.isArray(pathologyList)
        ? pathologyList
        : [pathologyList]; // ensure array form for consistency
    }

    console.log("RAI filter data (modified):", result.data);

    // ✅ Store the modified object safely in a cookie
    document.cookie = `filters=${encodeURIComponent(
      JSON.stringify(result.data)
    )}; domain=.deeptek.ai; path=/; max-age=${60 * 60 * 2}; secure; samesite=None`;

    // (optional) further mapping logic if needed
    const data = result.data.selectedPrediction;
    const findingsFilterOptions = (data.models || []).map((item) => ({
      label: item,
      value: item,
    }));
  } catch (error) {
    console.error("Failed to fetch filter data:", error);
  }
};


const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        const accessCode = searchParams.get("accessCode");
        const userName = searchParams.get("userName");

        if (!accessCode || !userName) {
            alert("Missing access code or username.");
            return;
        }

        const resolveAccessCode = async () => {
    try {
      const url = new URL(window.location.href);

      // extract values
      const accessCode = url.searchParams.get("accessCode");
      const userName = url.searchParams.get("userName");

      // log any specific parameter you want (e.g., pathologyList)
      const pathologyList = url.searchParams.getAll("pathologyList");
      console.log("🧬 Pathology List:", pathologyList);

      // call API
      const response = await fetch(
        `${API_BASE_URL}gizmo/resolve-access-code?code=${accessCode}&userName=${encodeURIComponent(userName)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Access code error:", errorText);
        alert("Access expired or invalid.");
        return;
      }

      const data = await response.json();
      console.log("Resolved access code:", data);

      // ✅ Remove accessCode & userName from URL
      url.searchParams.delete("accessCode");
      url.searchParams.delete("userName");
      window.history.replaceState({}, "", url.toString());

      // --- main logic ---
      if (data.isProductivityClicked) {
        navigate(AuthRoutes.ANALYTICS, {
          state: {
            widgetChartMode: data.chartMode,
            chartDateFrom: data.chartDateFrom,
            chartDateTo: data.chartDateTo,
            modalityIds: data.modalityIds,
          },
        });
      } else if (data.isRaiClicked) {
        await loginAndFetchToken();
        fetchFilterData(pathologyList);

        // ✅ Build dynamic redirect URL with remaining params
        const raiBase = "https://rai-demo.deeptek.ai/finding-analysis";
        const queryString = url.searchParams.toString();
        const redirectUrl = `${raiBase}?${queryString}`;

        console.log("🔗 Redirecting to:", redirectUrl);
        window.location.href = redirectUrl;
      } else {
        navigate(`/new/study/load/${data.studyId}?firmId=${data.firmId}`, {
          state: { widgetOpen: data.isReportClicked },
        });
      }
    } catch (error) {
      console.error("Failed to resolve access code:", error);
      alert("An error occurred. Please try again.");
    }
  };
        resolveAccessCode();
    }, [searchParams, navigate]);

    return <p>Resolving secure access... Please wait.</p>;
}

export default GizmoViewer;
